import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { useReveals } from "@/components/Reveal";
import { transitionTo } from "@/components/Transition";
import { BUSINESSES } from "@/data/businesses";
import { ArrowUpRight } from "lucide-react";

export default function Businesses() {
  useReveals();
  const navigate = useNavigate();
  const go = (e, href) => {
    e.preventDefault();
    transitionTo(navigate, href);
  };

  return (
    <main data-testid="businesses-page">
      <SEO
        title="Our Businesses — OA Holding CO LTD."
        description="The businesses of OA Holding: EuroVDC DataCenter, BidUniq, MV ARTAX, a 5-star resort in Paros, SoftMaya and OZZLABS. Different industries. One infrastructure mindset."
        path="/businesses"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "OA Holding Businesses",
          url: "https://oaholding.co/businesses",
        }}
      />

      <section className="px-[6vw] pb-16 pt-[22vh] md:pt-[26vh]">
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-amber md:text-xs" data-reveal>
          Portfolio
        </p>
        <h1 className="mt-6 font-display text-[12vw] font-black uppercase leading-[0.85] tracking-tighter md:text-[8vw]" data-reveal>
          Our Businesses
        </h1>
        <p className="mt-10 max-w-2xl font-display text-xl font-bold leading-snug tracking-tight text-bone/90 md:text-3xl" data-reveal>
          Different industries.{" "}
          <span className="text-amber">One infrastructure mindset.</span>
        </p>
      </section>

      <section className="border-t border-white/10" data-testid="businesses-index">
        {BUSINESSES.map((b, i) => (
          <a
            key={b.slug}
            href={`/businesses/${b.slug}`}
            onClick={(e) => go(e, `/businesses/${b.slug}`)}
            className="group relative block border-b border-white/10"
            data-testid={`business-row-${b.slug}`}
            data-reveal
          >
            <div className="grid items-center gap-6 px-[6vw] py-10 md:grid-cols-12 md:gap-8 md:py-14">
              <span className="font-mono text-xs text-smoke md:col-span-1">0{i + 1}</span>
              <div className="md:col-span-5">
                <h2 className="font-display text-3xl font-black uppercase leading-[0.95] tracking-tighter transition-transform duration-500 ease-out group-hover:translate-x-3 md:text-5xl">
                  {b.shortName}
                </h2>
                <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-amber">
                  {b.category}
                  {b.location ? ` — ${b.location}` : ""}
                </p>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-smoke">
                  {b.tagline}
                </p>
              </div>
              <div className="overflow-hidden md:col-span-5">
                <img
                  src={b.hero}
                  alt={b.name}
                  className="h-[30vh] w-full object-cover brightness-[0.75] contrast-[1.05] transition-transform duration-700 ease-out group-hover:scale-105 md:h-[36vh]"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="hidden justify-end md:col-span-1 md:flex">
                <span className="flex h-12 w-12 items-center justify-center border border-white/20 transition-all duration-300 group-hover:border-amber group-hover:bg-amber group-hover:text-ink">
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </section>
    </main>
  );
}
